module.exports = __webpack_public_path__ + "img/logo-sm.b62af53c.svg";